export const atomKeys = {
  variables: 'variables',
  document: 'document',
  backUpHistoryDocument: 'backUpHistoryDocument',
  projectInfo: 'projectInfo',
  activeCollaborators: 'activeCollaborators',
  collaborationRoomId: 'collaborationRoomId',
  collaborationDegraded: 'collaborationDegraded',
  contactList: 'contactList',
  templates: 'templates',
  savedBlocks: 'savedBlocks',
  commentsLoading: 'commentsLoading',
  comments: 'comments',
  commentsFetched: 'commentsFetched',
  reactions: 'reactions',
  builderSettings: 'builderSettings',
  activeThemePalette: 'activeThemePalette',
  documentVersionHistory: 'documentVersionHistory',
  draggedItem: 'draggedItem',
  containers: 'containers',
  dragSourceContainer: 'dragSourceContainer',
  currentProposalId: 'currentProposalId',
  projectInfoModal: 'projectInfoModal',
  sendViaEmailModal: 'sendViaEmailModal',
  sendViaLinkModal: 'sendViaLinkModal',
  expirationSettingsModal: 'expirationSettingsModal',
  reminderSettingsModal: 'reminderSettingsModal',
  sendEmailModal: 'sendEmailModal',
  addContactModal: 'addContactModal',
  editContactModal: 'editContactModal',
  activeViewPage: 'activeViewPage',
  isScrolling: 'isScrolling',
  aboutUsContentBlock: 'aboutUsContentBlock',
  contentBlockModal: 'contentBlockModal',
  rightSidebarAction: 'rightSidebarAction',
  createNewVariableModal: 'createNewVariableModal',
  newVariableKey: 'newVariableKey',
  editVariableModal: 'editVariableModal',
  deleteDocumentModal: 'deleteDocumentModal',
  versionHistoryModal: 'versionHistoryModal',
  restoreVersionModal: 'restoreVersionModal',
  shareVersionModal: 'shareVersionModal',
  shareVersionEmailComposerDirty: 'shareVersionEmailComposerDirty',
  shareVersions: 'shareVersions',
  selectedShareVersion: 'selectedShareVersion',
  pageBoundaryMetrics: 'pageBoundaryMetrics',
  forcedPageContentUuids: 'forcedPageContentUuids',
  agentPendingPageUuids: 'agentPendingPageUuids',
  liveShareLink: 'liveShareLink',
  mySections: 'mySections',
  addSectionModal: 'addSectionModal',
  myThemes: 'myThemes',
  myThemesLoaded: 'myThemesLoaded',
  newTheme: 'newTheme',
  settingsModal: 'settingsModal',
  headerFooterModal: 'headerFooterModal',
  exportDocumentModal: 'exportDocumentModal',
  sessionUser: 'sessionUser',
  userCantEditModal: 'userCantEditModal',
  saveAsTemplateModal: 'saveAsTemplateModal',
  contentBlockFormData: 'contentBlockFormData',
  isAnimate: 'isAnimate',
  highlightedBlock: 'highlightedBlock',
  canOnlyComment: 'canOnlyComment',
  canOnlyView: 'canOnlyView',
  canEdit: 'canEdit',
  passwordRequired: 'passwordRequired',
  headerLoading: 'headerLoading',
  isMetadataLoaded: 'isMetadataLoaded',
  blockActiveTab: 'blockActiveTab',
  sectionActiveTab: 'sectionActiveTab',
  themeActiveTab: 'themeActiveTab',
  themeEditorState: 'themeEditorState',
  themeEditorPendingAction: 'themeEditorPendingAction',
  leftSidebarPendingOption: 'leftSidebarPendingOption',
  isItemDragging: 'isItemDragging',
  inbuiltThemeList: 'inbuiltThemeList',
  editStatus: 'editStatus',
  pageRegenerationLoading: 'pageRegenerationLoading',
  isStreaming: 'isStreaming',
  isCapturingThumbnail: 'isCapturingThumbnail',
  isOutlineStreaming: 'isOutlineStreaming',
  documentEvaluationModal: 'documentEvaluationModal',
  documentEvaluationData: 'documentEvaluationData',
  createTheme: 'createTheme',
  firstDocumentBrandSetupDismissed: 'firstDocumentBrandSetupDismissed',
  initialBuilderSettings: 'initialBuilderSettings',
  contentBlocks: 'contentBlocks',
  socialLinks: 'socialLinks',
  socialLinksSheetOpen: 'socialLinksSheetOpen',
  socialLinksSheetContext: 'socialLinksSheetContext',
  aiCredits: 'aiCredits',
  analyticsBlockMap: 'analyticsBlockMap',
  filteredBlocks: 'filteredBlocks',
  lastUpdatedAt: 'lastUpdatedAt',
  confirmDiscardOpen: 'confirmDiscardOpen',
  isGeneratingContentModal: 'isGeneratingContentModal',
  streamedReasoning: 'streamedReasoning',
  analyticsLoading: 'analyticsLoading',
  rightSidebarToggleState: 'rightSidebarToggleState',
  sectionGalleryLoading: 'sectionGalleryLoading',
  sectionGallery: 'sectionGallery',
  rightSidebarCurrentMenuOption: 'rightSidebarCurrentMenuOption',
  projectAgentPendingHandoff: 'projectAgentPendingHandoff',
  projectAgentDraft: 'projectAgentDraft',
  mobileAgentDrawerOpen: 'mobileAgentDrawerOpen',
  mobileInsertSheet: 'mobileInsertSheet',
  mobileBarBlockUuid: 'mobileBarBlockUuid',
  exportPreventPageClipping: 'exportPreventPageClipping',
  activeBlockUuid: 'activeBlockUuid',
  activeSmartItemId: 'activeSmartItemId',
  unfilledSenderSignatureCount: 'unfilledSenderSignatureCount',
  // uuid of the image block whose picture is being replaced by an in-flight upload
  imageBlockReplacingUuid: 'imageBlockReplacingUuid',
  // Recipients
  proposalRecipients: 'proposalRecipients',
  recipientFieldAssignments: 'recipientFieldAssignments',
  recipientFieldRecords: 'recipientFieldRecords',
  // Display name of the document's sender, shown on sender badges in exports
  exportSenderName: 'exportSenderName',
  // Recipient context for view mode (which fields can be edited)
  recipientContext: 'recipientContext',
  // Present mode
  isPresentMode: 'isPresentMode',
  isFullscreenMode: 'isFullscreenMode',
  presentChromeVisible: 'presentChromeVisible',
  // Menu coordination (block vs card level)
  activeMenuLayer: 'activeMenuLayer',
  // Focused page tracking
  focusedPageUuid: 'focusedPageUuid',
  // Smart block layout picker
  smartBlockLayoutPickerOpen: 'smartBlockLayoutPickerOpen',
  smartBlockLayoutPickerBlockUuid: 'smartBlockLayoutPickerBlockUuid',
  smartBlockLayoutPickerContext: 'smartBlockLayoutPickerContext',
  // Smart block icon picker
  smartBlockIconPickerOpen: 'smartBlockIconPickerOpen',
  smartBlockIconPickerBlockUuid: 'smartBlockIconPickerBlockUuid',
  smartBlockIconPickerContext: 'smartBlockIconPickerContext',
  // Icon block picker
  iconBlockPickerOpen: 'iconBlockPickerOpen',
  iconBlockPickerBlockUuid: 'iconBlockPickerBlockUuid',
  iconBlockPickerContext: 'iconBlockPickerContext',
  blockSettingsAutoOpenQueue: 'blockSettingsAutoOpenQueue',
  mobileTappedBlock: 'mobileTappedBlock',
  activeCommentGutterBlock: 'activeCommentGutterBlock',
  guestSignupModal: 'guestSignupModal',
};
